<template>
  <div class="mt-6 md:mt-9">
    <footer class="border-t-2 border-red-900 bg-blue-900 mt-6 md:mt-9">
      <div class="flex flex-col md:flex-row px-5 py-8 w-96">
        <div class="w-100 md:w-1/6 flex justify-center">
          <img alt="NSW Government waratah" src="@/assets/doe-logo-white.png" class="self-center" width="90" />
        </div>
        <div class="w-full md:w-5/6 flex flex-col items-center md:flex-row md:items-start sm:justify-left">
          <div class="flex flex-col mb-4 md:mb-0 md:mx-3 items-center md:items-start">
            <p class="font-bold text-white text-lg">User Support</p>
                  
           <a href="/assets/Self Assessment and Quality Improvement Planning Portal User Guide.pdf"  target="_blank" class="no-underline mt-3">
              <span class="material-icons md-18" aria-hidden="true">
                article
              </span>
              <span class="underline">Guide to the Self-Assessment and Quality Improvement Planning Portal</span>
            </a>
         
            <a href="/assets/Self Assessment and Quality Improvement Planning Portal FAQs.pdf" target="_blank" class="no-underline mt-3">
              <span class="material-icons md-18" aria-hidden="true">
                web
              </span>
              <span class="underline">Self-Assessment and Quality Improvement Planning Portal Frequently Asked Questions</span>
            </a>
             <a href="https://education.nsw.gov.au/early-childhood-education/regulation-and-compliance/assessment-and-rating-process"  target="_blank" class="no-underline mt-3">
              <span class="material-icons md-18" aria-hidden="true">
                fact_check
              </span>
              <span class="underline">Assessment and Ratings resources</span>
            </a>
            <a href="tel:1800619113" class="no-underline mt-3">
              <span class="material-icons" aria-hidden="true">
                phone
              </span>
              <span class="underline">Information &amp; Enquiries Phone 1800 619 113</span> 
            </a>
            <a href="mailto:information@earlylearningcommission.nsw.gov.au" class="no-underline mt-3 mb-6">
              <span class="material-icons" aria-hidden="true">
                email
              </span>
              <span class="underline">Information &amp; Enquiries Email</span>
            </a>
            <p class="font-sans font-light text-white text-sm">
                &copy; {{ new Date().getFullYear() }} NSW Early Learning Commission | All rights reserved
            </p>
           </div>
        
        </div>
      </div>
  </footer>
  </div>
</template>

<script>
export default {
  name: "AppFooter"
};
</script>

<style scoped lang="scss">
.footer {
  font-family: Montserrat,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
}
a {
  color:white;
  font-size: 1rem;
  display: flex;
  align-items: flex-start;
  & span:nth-child(2){
    margin-left: 0.5rem;
  }
}

.material-icons {
  font-size: 18px;
  margin-top: 4px;
}
</style>
